import { useState, useEffect } from "react";
import { layout } from "../designTokens";

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < layout.breakpoint : false
  );
  useEffect(() => {
    let timeoutId;
    const handler = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsMobile(window.innerWidth < layout.breakpoint), 150);
    };
    window.addEventListener("resize", handler);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handler);
    };
  }, []);
  return isMobile;
}
